import { IExpression } from '../../schema/expressions/IExpression';
import { getExpressionValue } from '../../schema/expressions/evaluate/getExpressionValue';
import { materializeReferences } from '../../schema/expressions/evaluate/materializeReferencePath';
import { collectExpressionReferences } from '../../schema/expressions/references/collectExpressionReferences';
import { IHydrationContext } from '../IHydrationContext';
import { hydrateReferencesVariables } from './hydrateReferencesVariables';

export function hydrateExpressionValue(
  context: IHydrationContext,
  name: string,
  expression: IExpression | null | undefined,
) {
  const references = collectExpressionReferences(expression);
  const materialized = materializeReferences(references, name);
  const variables = hydrateReferencesVariables(context, materialized);
  return getExpressionValue({
    name,
    expression,
    references: materialized,
    variables,
  });
}
